import React from 'react';
import { Input } from '../shared/Input';

const TextareaField = ({ field, form, ...restProps }) => (
  <Input {...field} {...restProps} multiline />
);

export default React.memo(TextareaField);
